import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { FxAttempt, FxConversion, FxPair, FxPhase, FxQuote, FxRate } from '@/types/fx';
import type { Transaction, WalletBalance } from '@/types/financial-workspace';

export type FxConversionState = {
  scope: string;
  phase: FxPhase;
  pairs: FxPair[];
  pair: string;
  amount: string;
  balances: WalletBalance[];
  walletName: string;
  rate: FxRate | null;
  rates: Record<string, FxRate | null>;
  ratesLoading: boolean;
  quote: FxQuote | null;
  deadline: number;
  attempt: FxAttempt | null;
  result: FxConversion | null;
  history: Transaction[];
  error: string;
  errorCode: string;
  refreshNotice: string;
};
export const fxConversionInitialState: FxConversionState = {
  scope: '', phase: 'loading', pairs: [], pair: '', amount: '', balances: [], walletName: '', rate: null,
  rates: {}, ratesLoading: false,
  quote: null, deadline: 0, attempt: null, result: null, history: [], error: '', errorCode: '', refreshNotice: '',
};
const slice = createSlice({
  name: 'fx-conversion',
  initialState: fxConversionInitialState,
  reducers: {
    initializeFx(_state, { payload }: PayloadAction<string>) {
      return { ...fxConversionInitialState, scope: payload };
    },
    leaveFx(state, { payload }: PayloadAction<string>) {
      if (state.scope === payload) return fxConversionInitialState;
    },
    updateFx(state, { payload }: PayloadAction<{ scope: string; changes: Partial<Omit<FxConversionState, 'scope'>> }>) {
      if (state.scope === payload.scope) Object.assign(state, payload.changes);
    },
  },
  extraReducers: (builder) => {
    builder.addCase('auth/clearAuthDataAction', () => fxConversionInitialState);
    builder.addCase('entityContext/setCurrentEntity', () => fxConversionInitialState);
  },
});
export const { initializeFx, leaveFx, updateFx } = slice.actions;
export default slice.reducer;
